import amex from './Amex'
import discover from './Discover'
import mastercard from './Mastercard'
import paypal from './Paypal'
import stripe from './Stripe'
import visa from './Visa'

export {
  amex,
  discover,
  mastercard,
  paypal,
  stripe,
  visa
}
